import Vue from 'vue';
import { fetchTextBlocks } from '@/entities/text-block';
import { Env } from '@/shared/config/environment';

const state = {
  textBlocks: {},
  isLoadingTextBlocks: {},
  textBlocksError: {},
};

const mutations = {
  SET_TEXT_BLOCKS: (state, { page, textBlocks }) => {
    Vue.set(state.textBlocks, page, textBlocks);
  },
  SET_LOADING_TEXT_BLOCKS: (state, { page, isLoading }) => {
    Vue.set(state.isLoadingTextBlocks, page, isLoading);
  },
  SET_TEXT_BLOCKS_ERROR: (state, { page, error }) => {
    Vue.set(state.textBlocksError, page, error);
  },
};

const actions = {
  async fetchTextBlocks({ commit, dispatch }, page) {
    commit('SET_LOADING_TEXT_BLOCKS', { page, isLoading: true });
    commit('SET_TEXT_BLOCKS_ERROR', { page, error: null });
    commit('SET_TEXT_BLOCKS', { page, textBlocks: null });

    try {
      const textBlocks = await fetchTextBlocks(page);
      commit('SET_TEXT_BLOCKS', { page, textBlocks: textBlocks });

      return textBlocks;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити дані для сторінки';

      commit('SET_TEXT_BLOCKS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити дані для сторінки',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_TEXT_BLOCKS', { page, isLoading: false });
    }
  }
};

const getters = {
  isLoadingTextBlocks: state => page => state.isLoadingTextBlocks[page] || false,
  textBlocksError: state => page => state.textBlocksError[page] || null,

  isTextBlocksReady: state => page => { return state.isLoadingTextBlocks[page] === false && state.textBlocks[page] !== null; },
  getTextBlocks: state => (page, group) => { return state.textBlocks[page]?.filter((block) => block.group === group) || []; }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
